import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    noItems: 'No products or services',
    noItemsDescription:
      'To add an item, go to the Products and services page in the "Invoicing" tab',
    noResult: 'No result found',
    reset: 'Reset search',
  },
  fr: {
    noItems: 'Aucun produit ou service pour le moment',
    noItemsDescription:
      'Pour ajouter un produit, rendez-vous sur la page Produits et services dans l’onglet Facturation',
    noResult: 'Aucun résultat',
    reset: 'Réinitialiser la recherche',
  },
} as const);

export default locales;
